module.exports = __webpack_public_path__ + "static/logo-c22c01f624049f29da294d83c56b4e68.png";